'use client';

import tinycolor from "../../../external/tinycolor2/esm/tinycolor.js";
function isDark(color) {
  return tinycolor(color).isDark();
}
export {
  isDark
};
